export default __webpack_public_path__ + "static/media/pictogramBeaconDisability128.d6c5f22e.svg";